
<template>
  <v-app id="searchIpfc">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Sales partner Invoices</v-card-title>
      <v-simple-table dense>
        <thead>
           <tr>
             <th>Number</th>
             <th>Description</th>
             <th>Date / Time</th>
             <th>Host</th>
             <th>Country</th>
             <th>User</th>
           </tr>  
         </thead>
         <tbody v-for="(ipfcRecord,i) in searchIpfc" :key="i">
           <tr @click="$router.open('/task/inpt/ipfc/onIpfc/' + ipfcRecord.ipfc_encrid)">
             <td>{{ipfcRecord.ipfc_nr}}</td>
             <td>{{ipfcRecord.ipfc_oms}}</td>             
             <td>{{ipfcRecord.ipfc_dt}}</td>
             <td>{{ipfcRecord.inpt_naam}}</td>
             <td>{{ipfcRecord.land_code}}</td>
             <td>{{ipfcRecord.gebr_code}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Sales partners" :home="true" type="inpt"/>    
  </v-app>
</template>


<script>
 import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchIpfc: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/task/inpt/ipfc/searchIpfc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchIpfc"
          },
          searchIpfc: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchIpfc = res.data.searchIpfc;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
